module.exports = {
	"username": "ชื่อผู้ใช้",
	"password": "รหัสผ่าน",
	"login": "เข้าสู่ะระบบ",
	"register": "สมัครสมาชิก",
	"recaptchaRequired": "กรุณายืนยัน reCAPTCHA ก่อนเข้าสู่ระบบ",
	"recaptchaLoadFailed": "ไม่สามารถโหลด reCAPTCHA ได้ กรุณารีเฟรชแล้วลองใหม่อีกครั้ง",
	"recaptchaError": "การยืนยัน reCAPTCHA ล้มเหลว กรุณาลองใหม่อีกครั้ง",
	"name": "ชื่อ",
	"firstname": "ชื่อจริง",
	"lastname": "นามสกุล",
	"email": "อี-เมล",
	"passwordConfirmation": "ยืนยันรหัสผ่าน",
	"roles": "กลุ่ม",
	"rolesPlaceholder": "เลือกกลุ่มที่ต้องการ"
};


//////////////////
// WEBPACK FOOTER
// ./src/locale/th/auth.json
// module id = 834
// module chunks = 1